/*global angular */
'use strict';

angular.module('MrDWebApp').controller('PagesCtrl', function($scope, $http, formFactory, $state, $window) {

  var _pages = this;

  $window.scroll(0, 0); // Go To Top

  _pages.isWorking = false;
  _pages.isSuccess = false;
  _pages.isFailure = false;
  _pages.jobs = [];

  $scope._rc.bodyClass = 'html-pages';

  // Drivers
  if ($state.current.name === 'become-a-driver') {
    _pages.become_a_driver_template = {
      licence: false
    };
    _pages.signup_form = angular.copy(_pages.become_a_driver_template);
  }

  // Restaurant
  if ($state.current.name === 'become-a-restaurant-partner') {
    _pages.become_a_restaurant_template = {};
    _pages.signup_form = angular.copy(_pages.become_a_restaurant_template);
  }

  // Contact
  if ($state.current.name === 'contact') {
    _pages.contact_template = {};
    _pages.signup_form = angular.copy(_pages.contact_template);
  }

  _pages.filterOutMRDFOOD = function(input) {
    var output = input.replace('–','-');
    output = output.replace('- Mr D Food', '');
    output = output.replace('- MR D Food', '');
    output = output.replace('Mr D Food -', '');
    output = output.replace('MR D Food -', '');
    return output;
  };

  _pages.submit = function(type) {
    console.warn('Feature removed.');
  };

  if ($state.current.name === 'careers') {
    var url = 'https://api.greenhouse.io/v1/boards/takealotcom/jobs?callback=JSON_CALLBACK';
    _pages.isWorking = true;
    $http.jsonp(url)
    .success(function(data){
      _pages.isWorking = false;
      _pages.isSuccess = true;
      _pages.isFailure = false;
      _pages.jobs = data.jobs;
    }).error(function(){
      _pages.isWorking = false;
      _pages.isSuccess = false;
      _pages.isFailure = true;
    });

  }

  _pages.reasons = [
    'Orders',
    'Payments',
    'App and Web Support',
    'Compliment',
    'Complaint',
    'General Enquiry'
  ];

});
